module.exports = "<footer class=\"app-footer print-action-buttons\">\n  <span>BullsEyeSalesEvents &copy; {{date}}</span>\n  <span class=\"ml-auto\">Powered by <a href=\"https://www.aroracomfortechs.com\" target=\"_blank\">Comfortechs</a></span>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/portal/bullseye/src/app/components/app-footer/app-footer.component.html
// module id = ../../../../../src/app/components/app-footer/app-footer.component.html
// module chunks = main